// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elevation-24[data-v-67e1507b]{transition:box-shadow .2s ease-in}", ""]);
// Exports
module.exports = exports;
